export default {
  'environment.manageModal.title': 'Personal variables',
  'environmentDetail.label.server': 'Base URL',
  'environmentDetail.label.variables': 'Variables',
  'environmentDetail.label.variables.tips':
    'Insert {{var_name}} into parameter values to reuse values across different endpoints and parameters.',
  'environment.title.variableName': 'Name',
  'environment.title.variableName.placeholder': 'Add a new variable',
  'environment.title.addVariableValue': 'Add Variable',
  'environment.title.value': 'Value',
  variableNameEmptyError: 'Name is required',
  preFixUrl: 'Prefix Url',
  'editor.tip': 'The data format follows',
  filedBulkEdit: 'Bulk Edit',
  'environment.title.serviceName': 'Service Name',
  'environment.manageModal.tip':
    'These values are stored locally in your browser and will not be synchronized to the cloud.',
  'environment.manageModal.tip.clickToSetVariable':
    'Click to set the variable: {variableName} (Current value: {variableValue})',
  'baseURL.colon': 'Base URL: ',
  'environment.variable.notSet': 'Not set',
  byComma: 'By comma',
  byColon: 'By colon',
};
